import aboutUs from './aboutUs.png';
import amazonLogo from './amazonImage-WQAYYPOP.png';
import BannerHero from './banner.png';
import blog1 from './blog1.png';
import blog2 from './blog2.png';
import blog3 from './blog3.png';
import blog4 from './blog4.png';
import blog5 from './blog5.png';
import blog6 from './blog6.png';
import blog7 from './blog7.png';
import dashboardAws from './dashboardAws-CVGPUGJY.png';
import fa1 from './fa1-TQQMYHKO.png';
import fa2 from './fa2-O4XZU5E5.png';
import fa3 from './fa3-N2WTSN7I.png';
import fa4 from './fa4-BH5YINMR.png';
import fa5 from './fa5-DMUKBYXL.png';
import flipkartLogo from './flipkartImage-AMJUDVYN.png';
import graph from './grapgh.png';
import graphHomeImage from './graphHomeImage-5BJAQ47F.png';
import journey from './journey.png';
import Lines from './Lines.png';
import Maingraphimage from './Maingraphimage.png';
import meeshoLogo from './meeshoLogo-SNYASXH6.png';
import myntraLogo from './myntraLogo-XH7LSVEK.png';
import naykaLogo from './naykaLogo-IGYHOEZV.png';
import screen from './screen.png';
import referal from './referal.svg';
import logo from './V1.svg';
import dashboard from "./icons/dashboard.svg";
import ads from './icons/ads.svg';
import actionable from "./icons/actionable.svg";
import area from './icons/map-1.svg';
import time from './icons/sales.svg';
import growth from './icons/growth.svg';
import sales from './icons/Style7.svg';
import market from './icons/marketplace.svg';
import suggestions from './icons/suggestion.svg';
import refer from './icons/send.svg';
import bill from './icons/bill.svg';
import support from './icons/ticket.svg';
import arrowUp from './icons/ArrowRise.svg';
import arrowDown from './icons/ArrowFall.svg';

import dashboardfill from "./icons/dashboardfill.svg";
import adsfill from './icons/adsfill.svg';
import actionablefill from "./icons/actionablefill.svg";
import areafill from './icons/mapfill.svg';
import timefill from './icons/salesfill.svg';
import salesfill from './icons/Style8.svg';
import marketfill from './icons/datafill.svg';
import suggestionsfill from './icons/suggestionfill.svg';
import referfill from './icons/sendfill.svg';
import billfill from './icons/billfill.svg';
import supportfill from './icons/ticketfill.svg';

import Ajio from './icons/ajio.svg';
import Flipkart from './icons/flipkart.svg';
import Amazon from './icons/amazon.svg';
import Myntra from './icons/myntra.svg';
import AmazonAds from './icons/Amazon_Ads.svg';
import add from './icons/add.svg';
import sub from './icons/sub.svg';
import dummyImage from './dummyImg.jpg';
import marketPlace1 from "./growth-analytics.png";
import marketPlace2 from "./real-time-sync.png";
import marketPlace3 from "./cloud-hosting.png";
// import crown from "./icons/crown.png";
import homeImg from "./homeImg.png";
import homeBg from "./homeBg.png";
import gapalyz from './gapalyzBg.png';
import footerIcon from "./footerIcon.png";
import footerLogo from "./gapalyze_logo.svg";
import footerFb from "./footerFb.png";
import footerInsta from './footerInsta.png';
import footerTel from "./footerTel.png"; 
import dataFillImg from "./dataFillImg.png";
import dataImg from "./dataImg.png"
import priceBg from "./vector.png"
import mobileLogo from "./mobileLogo.png"
import mobileBtn from "./button.svg"
import rotate1 from "./rotateText1.png"
import rotate2 from "./rotateText2.png"
import rotate3 from "./rotateText3.png"
import rotate4 from "./rotateText4.png"
import rotate5 from "./rotateText5.png"
import rotateAnimation from"./rotateAnimation.gif"
import plusIcon from "./icons/plusIcon.svg"
import crossIcon from "./icons/crossIcon.svg"
import blog from "./blog.png"
import blogSub from "./blogSub.png"
import about from "./about.png"
import homeWhy from "./homeWhy.png"
import faqBg from "./faqs.png"
import contactBg from "./contact-us.png"
import blogBg from "./blogBg.png"
import pricBg from "./pricing.png"
import crown from "./icons/crown1.png"
import frame1 from "./frame1.png"
import frame2 from "./frame2.png"
import frame3 from "./frame3.png"
import frame4 from "./frame4.png"
import frame5 from "./frame5.png"
import aboutUsBgImage from './about-us.png'
import heroImage from "./hero_img.svg"
import blogInner from "./blog-inner-page.png"
import aboutImg from "./Abt_img.svg"
import dashboardL from "./dashboard.png"
import adsInsight from "./ads-insight.png"
import actionableInsights from "./action-img.png"
import productGrowth from "./product-growth.png"
import salesInsight from "./sales-insight.png"
import timeSale from "./time-sales.png"
import stepBg from "./step-bg.svg"
import dashboardImg from "./dashboard.svg"
import adsImg from "./_ads.svg"
import action from "./_action.svg"
import product from "./product.svg"
import geo from "./geo_sales.svg"
import timeImg from "./_time.svg"
import linkedIn from "./icons/linked_in.svg"
import about1 from "./icons/about1.svg"
import about2 from "./icons/about2.svg"
import about3 from "./icons/about3.svg"
import about4 from "./icons/about4.svg"
import about5 from "./icons/about5.svg"
import about6 from "./icons/about6.svg"
import about7 from "./icons/about7.svg"
import about8 from "./icons/about8.svg"
import faceBook from "./icons/fb.svg"
import instagram from "./icons/insta.svg"
import teamMember1 from "./sourabh_sir.svg"
import teamMember2 from "./shubham_sir.svg"
import aboutBlw from "./about_below.svg"
import orbitLeftLogo from "./orbit.svg"
import orbitRightLogo from "./orbit_gap.svg"

export {
	logo,
	aboutUs,
	arrowUp,
	arrowDown,
	dashboardL,
	adsInsight,
	actionableInsights,
	productGrowth,
	salesInsight,
	timeSale,
	dashboardImg,
	adsImg,
	action,
	product,
	geo,
	timeImg,
	stepBg,
	sales,
	market,
	suggestions,
	refer,
	bill,
	support,
	ads,
	actionable,
	area,
	time,
	growth,
	amazonLogo,
	BannerHero,
	blog1,
	blog2,
	blog3,
	blog4,
	blog5,
	blog6,
	blog7,
	dashboardAws,
	fa1,
	fa2,
	fa3,
	fa4,
	fa5,
	flipkartLogo,
	graph,
	graphHomeImage,
	journey,
	Lines,
	Maingraphimage,
	meeshoLogo,
	myntraLogo,
	naykaLogo,
	screen,referal,dashboard,
	dashboardfill,
	adsfill, 
	actionablefill,
	areafill,
	timefill,
	salesfill,
	marketfill,
	suggestionsfill,
	referfill,
	billfill,
	supportfill,
	Ajio,
	Flipkart,
	Amazon,
	Myntra,
	AmazonAds,
	add,
	sub,
	dummyImage,
	marketPlace1,
marketPlace2,
marketPlace3,
crown,
homeImg,
homeBg,
gapalyz,
footerIcon,
footerLogo,
footerFb,
footerTel,
footerInsta,
dataImg,
dataFillImg,
priceBg,
mobileLogo,
mobileBtn,
rotate1,
rotate2,
rotate3,
rotate4,
rotate5,
rotateAnimation,
plusIcon,
crossIcon,
blog,
about,
blogSub,
homeWhy,
faqBg,
contactBg,
blogBg,
pricBg,
frame1,
frame2,
frame3,
frame4,
frame5,
aboutUsBgImage,
heroImage,
blogInner,
aboutImg,
linkedIn,
about1,
about2,
about3,
about4,
about5,
about6,
about7,
about8,
faceBook,
instagram,
teamMember1,
teamMember2,
aboutBlw,
orbitLeftLogo,
orbitRightLogo


}
